import { StyledBorder } from '../atoms/DashedLabel';
import DateLabelMessage from '../dates/components/DateLabelMessage';
import styled from 'styled-components';
import { CIRRUS } from 'visitor-ui-component-library/constants/WidgetColors';
import { jsx as _jsx } from "react/jsx-runtime";
const StyleWrapper = styled.div.withConfig({
  displayName: "DateLabel__StyleWrapper"
})(["", "{border-color:", ";}"], StyledBorder, CIRRUS);
const DateLabel = props => {
  return /*#__PURE__*/_jsx(StyleWrapper, {
    children: /*#__PURE__*/_jsx(DateLabelMessage, Object.assign({}, props, {
      labelPadding: "m-y-3"
    }))
  });
};
DateLabel.displayName = 'DateLabel';
export default DateLabel;